import { render, staticRenderFns } from "./alerta.vue?vue&type=template&id=4709257f&"
import script from "./alerta.vue?vue&type=script&lang=js&"
export * from "./alerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports